import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { useEffect, useMemo, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { apiInstance } from "@repo/core/services/instances/api";
import { usePreProposal } from "../../hooks/usePreProposal";
import { CommonResource } from "@repo/core/services/resources/common";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { persistPreProposalAlterarDataConferencePendingOrThrow } from "../../services/persistPreProposalAlterarPending.service";
import { usePreProposalStore } from "../../store/preProposalStore";
import useToast from "@repo/core/components/core/Toast";

const commonResource = new CommonResource(apiInstance);

export const FinancialServiceController = () => {
  const alertModalRef = useRef<IModalRefProps>(null);

  const { back, push } = useNavigation();
  const { isTabletOrWeb } = useDimensions();
  const { proposalData, setProposalData } = usePreProposal();
  const toast = useToast();

  const [selectedIdFinancialService, setSelectedIdFinancialService] = useState<
    number | null
  >(null);

  const {
    data: financialServicesResponse,
    isLoading: isLoadingFinancialServices
  } = useQuery({
    queryKey: ["financialServices", proposalData?.strProduto],
    queryFn: () =>
      commonResource.fetchBenefitsList(proposalData?.strProduto || ""),
    select: (data) => data.data
  });

  const financialServices = useMemo(() => {
    const services = [];
    financialServicesResponse?.forEach((service) => {
      services.push({
        id: service.intPacote,
        title: service.strDescricao
      });
    });

    services.push({
      id: -1,
      title: "Sem benefícios"
    });

    return services;
  }, [financialServicesResponse]);

  const handleSelectFinancialService = (id: number) => {
    setSelectedIdFinancialService(id);
    if (id !== -1) {
      setProposalData(
        { intPacoteBeneficio: Number(id) },
        { skipAlterarSync: true }
      );
    }
  };

  const handleOnSubmitForm = async () => {
    const latestSnapshot = usePreProposalStore.getState().proposalData;
    if (latestSnapshot?.lngProposta) {
      try {
        await persistPreProposalAlterarDataConferencePendingOrThrow(
          latestSnapshot
        );
      } catch {
        toast.error(
          "Erro ao salvar etapa",
          "Não foi possível sincronizar com o servidor. Tente novamente."
        );
        return;
      }
    }
    push(ROUTES.preProposalsVerifyInformations);
  };

  useEffect(() => {
    if (financialServices?.length) {
      setSelectedIdFinancialService(financialServices[0].id);
    }
  }, [financialServices]);

  useEffect(() => {
    // Temporary redirect - skip FinancialService screen
    // TODO: Remove this when financial service flow is restored
    push(ROUTES.preProposalsVerifyInformations);
  }, []);
  return {
    alertModalRef,
    handleOnSubmitForm,
    isLoadingFinancialServices,
    back,
    financialServices,
    isTabletOrWeb,
    selectedIdFinancialService,
    handleSelectFinancialService
  };
};
